import {useState, useEffect} from 'react'
import Modal from '../Modal'
import { AmlRiskClass } from '../../redux/companyMonitorTypes'
import Select from '../Select'

interface Props {
  intitialValue: AmlRiskClass
  onSaveClick?: (riskClass: AmlRiskClass) => void
  onCancelClick?: () => void
  onHideClick?: () => void
  visible: boolean
}

const SetCompandAmlRiskClassificationModal = (props: Props) => {
  const [riskClass, setRiskClass] = useState<AmlRiskClass>(AmlRiskClass.low)

  useEffect(() => {
    setRiskClass(props.intitialValue)    
  }, [props.intitialValue])

  const handleOnSave = () => {
    props.onSaveClick && props.onSaveClick(riskClass)
  }

  const handleOnCancel = () => {
    props.onCancelClick && props.onCancelClick()
  }

  const handleOnHide = () => {
    props.onHideClick && props.onHideClick()
  }

  const getRiskClassOptions = () => {
    return Object.keys(AmlRiskClass).filter(v => isNaN(Number(v)))
        .map((value) => { return { name: value, value: value }
    })
  }

  return (
    <Modal
      title={'Set AML risk classification'}
      show={props.visible}
      onHide={() => handleOnHide()}
      onOkClick={() => handleOnSave()}
      onCancelClick={() => handleOnCancel()}
    >
      <Select
          id='riskClass'
          key='riskClass'
          label='Risk class'
          options={getRiskClassOptions()}
          selectedValue={riskClass.toString()}
          onSelect={(value) => setRiskClass(value as any)}
      />
    </Modal>
  )
}

export default SetCompandAmlRiskClassificationModal
